import { RDTillage, TillageImplement } from '@cibo/core'

import * as Yup from 'yup'
import { ITraitFeatureByIdYear, ValidationSchemaFunctionArguments } from '..'
import { eventValidationSchema } from '../EventDetail'
import { isDetailRequired } from '../useIsRequired'
import { findInitialValuesDetail } from '../utils'
import { TillageCell } from './TillageCell'
import { TillageCellEditor } from './TillageCellEditor'
import { TillageEditor } from './TillageEditor'
import { TillageTableCta } from './TillageTableCta'

const TRAIT_ID = 'tillage'

export const TillageEventValidationSchema = ({
  t,
  requirement,
}: ValidationSchemaFunctionArguments) =>
  Yup.object()
    .shape({
      date: Yup.date()
        .required(t('required', { context: 'date' }))
        .typeError(t('required', { context: 'date' })),
      implement: Yup.string<TillageImplement>()
        .required(t('required', { context: 'implement' }))
        .typeError(t('required', { context: 'implement' })),
      depth: Yup.number()
        .min(0, t('min', { context: 'depth' }))
        [isDetailRequired({ requirement, fieldName: 'depth' }) ? 'required' : 'optional'](
          t('required', { context: 'depth' })
        ),
      rowSpacing: Yup.number().when('implement', {
        is: 'stripTill',
        then: Yup.number()
          .min(0, t('min', { context: 'rowSpacing' }))
          .required(t('required', { context: 'rowSpacing' }))
          .typeError(t('required', { context: 'rowSpacing' })),
      }),
      stripWidth: Yup.number().when('implement', {
        is: 'stripTill',
        then: Yup.number()
          .min(0, t('min', { context: 'stripWidth' }))
          .required(t('required', { context: 'stripWidth' }))
          .typeError(t('required', { context: 'stripWidth' })),
      }),
      residueRemaining: Yup.number()
        .min(0, t('min', { context: 'residueRemaining' }))
        .max(1, t('max', { context: 'residueRemaining' }))
        .required(t('required', { context: 'residueRemaining' }))
        .typeError(t('required', { context: 'residueRemaining' })),
    })
    .required()

export const TillageInput: ITraitFeatureByIdYear<RDTillage> = {
  traitId: TRAIT_ID,
  cellDisplay: TillageCell,
  editor: TillageEditor,
  tableCta: TillageTableCta,
  ns: '@cibo/landmanager/TillageEditor',
  validationSchema: eventValidationSchema<RDTillage['input']>(props =>
    TillageEventValidationSchema(props)
  ),

  initialValues: request => {
    const detail = findInitialValuesDetail(TRAIT_ID)(request)
    return detail?.input || {}
  },
}

export const TillageResult: ITraitFeatureByIdYear<RDTillage> = {
  traitId: TRAIT_ID,
  editor: TillageEditor,
  cellDisplay: TillageCell,
  cellEditor: TillageCellEditor,
  tableCta: TillageTableCta,

  initialValues: request => {
    const detail = findInitialValuesDetail(TRAIT_ID)(request)
    return detail?.result || {}
  },
  ns: '@cibo/landmanager/TillageEditor',
  // @ts-ignore not used - we should make optional or disallow for result traits
  validationSchema: () => Yup.object().nullable(),
}
